import { useCallback, useSyncExternalStore } from "react";

import type { PwaController } from "./PwaController";
import type { PwaStatusSnapshot } from "./types";

export interface UsePwaStatusOptions {
  controller: PwaController;
}

export interface PwaStatusApi {
  status: PwaStatusSnapshot;
  dismissCacheFailure(): void;
}

export function usePwaStatus({ controller }: UsePwaStatusOptions): PwaStatusApi {
  const status = useSyncExternalStore(
    controller.subscribe,
    controller.getSnapshot,
    controller.getSnapshot
  );

  const dismissCacheFailure = useCallback(
    () => controller.dismissCacheFailure(),
    [controller]
  );

  return {
    status,
    dismissCacheFailure
  };
}
